import request from "@Utils/api";
import api from "@Configs/apiConfig";

function getLogs(startTime) {
  var qString = "?starttime=" + startTime;
  return request({
    url:
      api.userServer +
      "/user/" +
      localStorage.getItem("Id") +
      "/logs" +
      qString,
    method: "GET",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function getFilters() {
  return request({
    url: api.userServer + "/user/" + localStorage.getItem("Id") + "/filters",
    method: "GET",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function addFilter(data) {
  return request({
    url: api.userServer + "/user/" + localStorage.getItem("Id") + "/filters",
    data: data,
    method: "POST",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function removeFilter(filterId) {
  return request({
    url:
      api.userServer +
      "/user/" +
      localStorage.getItem("Id") +
      "/filters/" +
      filterId,
    method: "DELETE",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function getSubfilters() {
  return request({
    url: api.userServer + "/user/" + localStorage.getItem("Id") + "/subfilters",
    method: "GET",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function getInfo() {
  return request({
    url: api.userServer + "/user/" + localStorage.getItem("Id"),
    method: "GET",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function updateInfo(data) {
  return request({
    url: api.userServer + "/user/" + localStorage.getItem("Id"),
    method: "PUT",
    data: data,
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function getUsersByCustomer() {
  return request({
    url: api.userServer + "/user/_by_customer",
    method: "GET",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function updatePassword(data) {
  return request({
    url: api.userServer + "/user/" + localStorage.getItem("Id") + "/password",
    method: "PUT",
    data: data,
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "text/plain",
    },
  });
}

function updateMediaInfoConfig(data) {
  return request({
    url:
      api.userServer +
      "/user/" +
      localStorage.getItem("Id") +
      "/media_info_config",
    method: "POST",
    data: data,
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

function getFilterCount(id) {
  return request({
    url:
      api.userServer +
      "/user/" +
      localStorage.getItem("Id") +
      "/filters/" +
      id +
      "/result_count",
    method: "GET",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
    },
  });
}

function swapFilterOrder(id1, id2) {
  return request({
    url:
      api.userServer +
      "/user/" +
      localStorage.getItem("Id") +
      "/filters/_swap_order",
    method: "POST",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
    },
    data: { id1: id1, id2: id2 },
  });
}

function reorderFilters(idOrderArray) {
  return request({
    url:
      api.userServer +
      "/user/" +
      localStorage.getItem("Id") +
      "/filters/_reorder",
    method: "POST",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
    },
    data: idOrderArray,
  });
}

function resetPassword(email) {
  return request({
    url: api.userServer + "/user/_reset_password/" + email,
    method: "POST",
  });
}

function setNewPassword(userid, temporaryToken, password) {
  return request({
    url: api.userServer + "/user/" + userid + "/password",
    method: "PUT",
    data: password,
    headers: {
      "x-access-token": temporaryToken,
      "Content-Type": "text/plain",
    },
  });
}

function validateResetPasswordID(rpId) {
  return request({
    url: api.userServer + "/user/_check_password_reset_id",
    method: "POST",
    data: { security_id: rpId },
  });
}

function getWatermarkProviders() {
  return request({
    url: api.userServer + "/watermarkproviders",
    method: "GET",
    headers: {
      "x-access-token": localStorage.getItem("Token"),
    },
  });
  /*
  return new Promise((resolve, reject) => {
    resolve([
      {
        id: "7d98ef73-af49-41fd-a763-9e072c545fdb",
        name: "Provider 1",
        logoUrl: "http://localhost:3000/Bildschirmfoto_20260605_104656.png",
        disclaimer: "Disclaimer of provider 1",
        active: true,
        connected: true,
        showUnconfirmedFindings: false,
        tags: [{id: "tagid1", name: "tag1"}, {id: "tagid2", name: "tag2"}]
      },
      {
        id: "8a9b7c6d-1234-5678-9101-112131415161",
        name: "Provider 2",
        logoUrl: "http://localhost:3000/hado.png",
        disclaimer: "Disclaimer of provider 2",
        active: false,
        connected: false,
        showUnconfirmedFindings: false,
        tags:[]
      },
    ]);
  });

  */
}

/**
 *
 * @param {string} providerId Name of the provider, e.g. "imatag"
 * @param {{ active: boolean,apiKey:string,tags: Array<string>, showUnconfirmedFindings: boolean }} settings
 * @returns
 */
function saveWatermarkProviderSettings(providerId, settings) {
  return request({
    url: api.userServer + "/watermarkproviders/" + providerId + "/settings",
    method: "PUT",
    data: settings,
    headers: {
      "x-access-token": localStorage.getItem("Token"),
      "Content-Type": "application/json",
    },
  });
}

const User = {
  getLogs,
  getFilters,
  getSubfilters,
  addFilter,
  removeFilter,
  getInfo,
  updateInfo,
  updatePassword,
  getUsersByCustomer,
  updateMediaInfoConfig,
  getFilterCount,
  swapFilterOrder,
  reorderFilters,
  resetPassword,
  setNewPassword,
  validateResetPasswordID,
  getWatermarkProviders,
  saveWatermarkProviderSettings,
};

export default User;
